import { START_CLAN_EDIT, UPDATE_CLAN_EDIT_STATE, UPDATE_CLAN_EDIT_ERROR } from "../Actions/ActionClanEdit";

export const clanEdit = (state = {}, action) => {
  let error = null,
      savedState = null,
      data = null;
  switch (action.type) {
    case START_CLAN_EDIT:
      data = Object.assign({}, state[action.stateBranch], {
        isFetching: true
      });
      return Object.assign({}, state, {
        [action.stateBranch]: data
      });
    case UPDATE_CLAN_EDIT_STATE:
      data = Object.assign({}, action.data, {
        isFetching: false
      });
      return Object.assign({}, state, {
        [action.stateBranch]: data
      });
    case UPDATE_CLAN_EDIT_ERROR:
      if (!action.data) {
        error = null;
      } else {
        error = action.data.current || action.data.errors || { message: action.data.error };
        error.system_error = error.system_error || (action.data && action.data.system_error);
      }

      savedState = Object.assign({}, state[action.stateBranch], {
        error,
        isFetching: false
      });
      return Object.assign({}, state, {
        [action.stateBranch]: savedState
      });
    default:
      return state;

  }
};